export default "/images/img-job.png?6d35993e7577ee0a01354fd6e76342b6";